import React, { useContext, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import blogFetch from '../../../../axios/config';
import Context from '../../../../context/Context'
import toast from "react-hot-toast";
import language from '../../../../nls/language.json';

export const ConfirmModal = (
  { show,
    handleClose,
    handleConfirm,
    wagon,
    partsByFurnace,
    selectedWagon,
    setIsEdit,
    INITIAL_VALUE,
    reset,
    setShowConfirmModal,
  }) => {
  const {
    selectedCountry,
    selectedFurnace,
    getConfirmedWagon,
    getPartsByFurnace,
  } = useContext(Context);


  const checkArray = (data, array, wagon) => {
    const parts = partsByFurnace.map((item) => item.pecasSetor.ordem_Serial)
    data.wagon.forEach((z) => {
      if (array.every((e) => e.Ordem_Serial !== z.ordem_Serial)) {
        array.push({
          Ordem_Serial: z.ordem_Serial,
          Sugerida: wagon.some((d) => z.ordem_Serial === d.ordem_Serial),
          Ativo: true,
          Posicao_Lista: parts.indexOf(z.ordem_Serial) >= 0 ? parts.indexOf(z.ordem_Serial) + 1 : null,
          Reprocesso: !!z.isReprocesso,
          ReprocessoDireto: !!z.isReprocessoDireto,
        })
      } else {
        const alterAtivo = array.find((f) => f.Ordem_Serial === z.ordem_Serial)
        alterAtivo.Ativo = true
      }
    })

    return array;
  };

  const getMatricula = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.user_SAPMatricula;
  };

  // Mensagens de bloqueio do backend (ex.: reprocesso sem apontamento em aberto,
  // mais de 2 peças de reprocesso) vêm no corpo do erro — repassamos ao operador.
  const getErrorMessage = (err) => {
    const apiData = err?.response?.data;
    if (typeof apiData === "string") return apiData;
    return apiData?.message || apiData?.mensagem || null;
  };

  const putObjWagon = async (data) => {
    try {
      await blogFetch.put(`/ISAGA_VagoesFornos`, data);
      toast.success("Vagão alterada com sucesso", {
        duration: 4000
      })
    } catch (err) {
      toast.error(getErrorMessage(err) || "Erro ao alterar o vagão", {
        duration: 6000
      })
      console.error("Error", err);
    }
    getConfirmedWagon()
  }

  const postObjWagon = async (data) => {
    try {
      const { data: resp } = await blogFetch.post(`/ISAGA_VagoesFornos`, data);
      const puladas = Array.isArray(resp?.ordemSerialsPuladas) ? resp.ordemSerialsPuladas : [];
      const reprocessos = Array.isArray(resp?.reprocessosConsumidos)
        ? resp.reprocessosConsumidos
        : (Array.isArray(resp?.ReprocessosConsumidos) ? resp.ReprocessosConsumidos : []);
      const serial = resp?.vagao_Serial ?? "";

      if (reprocessos.length > 0) {
        const listaReproc = reprocessos.map((s) => `• ${s}`).join('\n');
        toast(
          (t) => (
            <span style={{ display: 'flex', alignItems: 'flex-start', gap: 8, whiteSpace: 'pre-line' }}>
              {`♻️ Reprocesso(s) de forno atendido(s):\n${listaReproc}`}
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}
              >✕</button>
            </span>
          ),
          { duration: 6000, style: { background: '#198754', color: '#fff', fontWeight: '500' } }
        );
      }

      if (puladas.length === 0) {
        toast.success(
          serial
            ? `Vagão ${serial} criado com sucesso`
            : language[selectedCountry.name].PainelFornos.notification.successAddWagon,
          { duration: 4000 }
        );
      } else {
        const MAX_LIST = 5;
        const lista = puladas.slice(0, MAX_LIST).map((s) => `• ${s}`).join('\n');
        const extra = puladas.length > MAX_LIST ? `\n+${puladas.length - MAX_LIST} outra(s)` : '';
        const cabecalho = serial
          ? `Vagão ${serial} criado, mas ${puladas.length} peça(s) foram puladas (já alocadas em outro vagão ativo):`
          : `Vagão criado, mas ${puladas.length} peça(s) foram puladas (já alocadas em outro vagão ativo):`;

        toast(
          (t) => (
            <span style={{ display: 'flex', alignItems: 'flex-start', gap: 8, whiteSpace: 'pre-line' }}>
              {`⚠️ ${cabecalho}\n${lista}${extra}`}
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}
              >✕</button>
            </span>
          ),
          { duration: 7000, style: { background: '#FFC107', color: '#000', fontWeight: '500' } }
        );
      }
    } catch (err) {
      toast.error(
        getErrorMessage(err) || language[selectedCountry.name].PainelFornos.notification.errorAddWagon,
        { duration: 6000 }
      )
      console.error("Error", err);
    }
    getConfirmedWagon();
    getPartsByFurnace(selectedFurnace);
  };

  const handleSaveWagon = (wagonData) => {
    // const checkWagon = wagonData.find((item) => item.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key)
    // if (!checkWagon.wagon.length) {
    //   toast.error(language[selectedCountry.name].PainelFornos.notification.errorAdd, {
    //     duration: 4000
    //   })
    //   return
    // }
    const parts = partsByFurnace.map((item) => item.pecasSetor.ordem_Serial)
    let array = []
    selectedWagon.wagon.forEach((a) => {
      array.push({
        Ordem_Serial: a.ordem_Serial,
        Sugerida: true,
        Reprocesso: !!a.isReprocesso,
        ReprocessoDireto: !!a.isReprocessoDireto,
        Ativo: wagonData.some((b) => {
          if (!!b.wagonInfo?.vagao_Key && b.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vgao_Key)
            return b.wagon.some((c) => c.ordem_Serial === a.ordem_Serial)
          else if (b.tipoCombinacaoPeca?.tipoComb_Key === selectedWagon.tipoCombinacaoPeca?.tipoComb_Key)
            return b.wagon.some((c) => c.ordem_Serial === a.ordem_Serial)

          return false
        }),
        Posicao_Lista: parts.indexOf(a.ordem_Serial) >= 0 ? parts.indexOf(a.ordem_Serial) + 1 : null
      })
    })
    wagonData.forEach((x) => {
      if (!!x.wagonInfo?.vagao_Key && x.wagonInfo?.vagao_Key === selectedWagon.wagonInfo?.vagao_Key)
        array = checkArray(x, array, selectedWagon.wagon);

      else if (!x.wagonInfo?.vagao_Key && x.tipoCombinacaoPeca.tipoComb_Key === selectedWagon.tipoCombinacaoPeca.tipoComb_Key)
        array = checkArray(x, array, selectedWagon.wagon);
    });
    const nroMatricula = getMatricula();
    selectedWagon.wagonInfo?.vagao_Key
      ? putObjWagon({
        vagao_Key: selectedWagon?.wagonInfo?.vagao_Key,
        pieces: array,
        Nro_Matricula: nroMatricula,
      })
      : postObjWagon({
        TipoComb_Key: selectedWagon.tipoCombinacaoPeca.tipoComb_Key,
        pieces: array,
        Nro_Matricula: nroMatricula,
      })
    setIsEdit(INITIAL_VALUE)
    reset()
    setShowConfirmModal(false);
  };

  const handleModalClose = () => {
    setShowConfirmModal(false);
    handleClose();
  };

  return <Modal show={show} onHide={handleModalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Confirmar Ação</Modal.Title>
    </Modal.Header>
    <Modal.Body>Tem certeza que deseja confirmar?</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleModalClose}>
        Não
      </Button>
      <Button variant="primary" onClick={() => handleSaveWagon(wagon)}>
        Sim
      </Button>
    </Modal.Footer>
  </Modal>

}

